module.exports = __webpack_public_path__ + "img/1993_S.b3f7832e.png";